import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldX, ArrowLeft } from 'lucide-react';

const OEMAccessDenied = ({ message = "You don't have permission to access this page." }) => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden">
        <div className="p-8 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <ShieldX className="h-8 w-8 text-red-600" />
          </div>
          <h2 className="text-xl font-bold text-slate-900 mb-2">Access Denied</h2>
          <p className="text-slate-600 mb-6">{message}</p>
          <p className="text-sm text-slate-500 mb-6">
            This action requires Master privileges. Please contact your administrator if you need access.
          </p>
          <button
            onClick={() => navigate('/oem')}
            className="h-10 px-6 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2 font-medium mx-auto transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default OEMAccessDenied;
